import normal from '../../Quiz/Presets/normal.json';

export default { normal };
